import type { ElementSettings } from '../types';
import type { ActiveDataBinding } from '../../runtime/dataServices/types';

export type ContainCoverFit = 'contain' | 'cover';
export type ImageAlignment = 'left' | 'center' | 'right';
export type ImageSizing = 'auto' | 'custom';

type ImageBinding = ActiveDataBinding;

interface BaseImageSettings extends ElementSettings {
    binding: ImageBinding | null;
    alt: string;
    alignment?: ImageAlignment;
    marginTop?: number;
    marginRight?: number;
    marginBottom?: number;
    marginLeft?: number;
}

export type ImageSettings = BaseImageSettings &
    (
        | { sizing?: undefined }
        | { sizing: 'auto' }
        | {
              sizing: 'custom';
              fit: ContainCoverFit;
              width: string;
              height: string;
          }
    );

export function createDefaultImageSettings(): ImageSettings {
    return {
        binding: null,
        alt: gettext('ELEMENT_IMAGE_DEFAULT_ALT_TEXT'),
    };
}
